// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__NyAq8","menu":"Menu_menu__d7dQ8","Show":"Menu_Show__rpbKm"};